import React from 'react';
import { TableRow, TableCell, Skeleton, Box } from '@mui/material';

/**
 * TableSkeleton - renders skeleton loading rows for DynamicTable
 */
export const TableSkeleton = ({
    columns,
    rowCount = 5,
    enableSelection = false,
    actionsRenderer = null
}) => {
    return (
        <>
            {Array.from({ length: rowCount }).map((_, rowIdx) => (
                <TableRow key={`skeleton-${rowIdx}`}>
                    {enableSelection && (
                        <TableCell padding="checkbox" sx={{ position: 'sticky', left: 0, background: 'white', zIndex: 1 }}>
                            <Skeleton variant="rectangular" width={20} height={20} />
                        </TableCell>
                    )}
                    {columns.map((col, colIdx) => (
                        <TableCell key={`skeleton-${rowIdx}-${colIdx}`} align={col.align || 'left'}>
                            <Skeleton
                                variant="text"
                                width={col.width ? `${Math.min(col.width * 0.7, 200)}px` : '80%'}
                                height={20}
                            />
                        </TableCell>
                    ))}
                    {actionsRenderer && (
                        <TableCell sx={{ position: 'sticky', right: 0, background: 'white', zIndex: 1 }}>
                            <Skeleton variant="circular" width={24} height={24} />
                        </TableCell>
                    )}
                </TableRow>
            ))}
        </>
    );
};

export default TableSkeleton;